module.exports = __webpack_public_path__ + "static/media/work.7710dd1d.jpg";